import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { MailCheck } from 'lucide-react';
import memberApi from '../../lib/memberApi';
import { AuthLayout, inputCls } from '../../components/member/AuthLayout';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [done, setDone] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const res = await memberApi.post('/members/auth/forgot', { email });
      setDone(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'İşlem başarısız');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (done) {
    return (
      <AuthLayout title="Bağlantı Gönderildi" testid="forgot-success">
        <div className="text-center space-y-3">
          <MailCheck className="w-12 h-12 text-[hsl(var(--gold))] mx-auto" />
          <p className="text-sm text-muted-foreground">{done.message}</p>
          {done.dev_reset_link && (
            <div className="text-xs bg-secondary rounded-lg p-3 break-all">
              <span className="font-semibold block mb-1">Geliştirici Modu — Sıfırlama Bağlantısı:</span>
              <a href={done.dev_reset_link} className="text-[hsl(var(--gold))] hover:underline" data-testid="forgot-dev-link">{done.dev_reset_link}</a>
            </div>
          )}
          <Link to="/uye/giris" className="inline-block mt-2 text-sm text-[hsl(var(--gold))] font-medium hover:underline">Girişe dön</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Şifremi Unuttum" subtitle="E-posta adresinize sıfırlama bağlantısı gönderelim" testid="forgot-page"
      footer={<Link to="/uye/giris" className="text-[hsl(var(--gold))] font-medium hover:underline">Girişe dön</Link>}>
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-form">
        <div>
          <label className="block text-sm font-medium mb-1.5">E-posta</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required data-testid="forgot-email" />
        </div>
        <button type="submit" disabled={isSubmitting}
          className="w-full px-4 py-2.5 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] font-medium text-sm hover:bg-[hsl(var(--gold)/0.92)] active:scale-[0.98] transition-colors duration-200 disabled:opacity-50"
          data-testid="forgot-submit">
          {isSubmitting ? 'Gönderiliyor...' : 'Bağlantı Gönder'}
        </button>
      </form>
    </AuthLayout>
  );
}
